module.exports = __webpack_public_path__ + "img/img.a915b22f.png";